// Tiny human-readable relative formatter for the BlameRow. Studio
// doesn't ship a full i18n layer yet, so we keep this English-only;
// when localisation lands, swap to `Intl.RelativeTimeFormat`.

export function formatRelativeDate(at: number, now: number = Date.now()): string {
  const deltaMs = Math.max(0, now - at);
  const s = Math.floor(deltaMs / 1000);
  if (s < 60) return "just now";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} minute${m === 1 ? "" : "s"} ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} hour${h === 1 ? "" : "s"} ago`;
  const d = Math.floor(h / 24);
  if (d < 30) return `${d} day${d === 1 ? "" : "s"} ago`;
  const mo = Math.floor(d / 30);
  if (mo < 12) return `${mo} month${mo === 1 ? "" : "s"} ago`;
  const y = Math.floor(d / 365);
  return `${y} year${y === 1 ? "" : "s"} ago`;
}
